import Observer from '../../common/scripts/observer';
import {Utils} from '../../common/scripts/utils';

const observer = new Observer();

class CompareState {
    constructor() {
        /**
         * Цвелевой элемент
         * @type {Element}
         */
        this.wrapper = null;

        /**
         * Обёртка вывода кол-ва сравнения
         * @type {Element}
         */
        this.countWrapper = null;

        /**
         * Таймер для отсчёта показа сообщения о добавлении
         * @type {null}
         */
        this.timer = null;
    }

    /**
     * Инициализация
     * @param {object} options - параметры
     */
    init(options) {
        this.wrapper = options.wrapper;

        this._getElements();
        this._subscribers();
    }

    /**
     * Получение элементов
     * @private
     */
    _getElements() {
        this.countWrapper = this.wrapper.querySelector('.j-compare-state-count');
    }

    /**
     * Показывает кол-во элементов в сравнении
     * @private
     * @param {number} count - количество квартир в сравнении
     */
    _showCount(count) {
        if (!this.countWrapper) {
            return;
        }

        if (Number(count) > 0) {
            const value = Number(count) > 9 ? '9+' : count;

            this.countWrapper.innerText = value;
            this.countWrapper.classList.remove('is-empty');
        } else {
            this.countWrapper.innerText = '';
            this.countWrapper.classList.add('is-empty');
        }
    }

    /**
     * Получаем список добавленных в сравнение квартир из куки
     * @returns {array} список сравнения из куки
     */
    _getCompare() {
        const cookieCompare = Utils.getCookie('compare');

        if (!cookieCompare) {
            return [];
        }

        return JSON.parse(cookieCompare);
    }

    /**
     * Подписка
     * @private
     */
    _subscribers() {
        observer.subscribe('compare:update', (count) => {
            this._showCount(count);
        });
    }
}

export default CompareState;
